import { Tooltip, WithNAFallback } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './UnderwritersCell.module.scss';

export const UnderwritersCell = ({
  leadUnderwriters,
  otherUnderwriters,
}: {
  leadUnderwriters: string[];
  otherUnderwriters: string[];
}) => {
  const { t } = useTranslation('screener');

  const formattedLeadUnderwriters = (
    <WithNAFallback
      check={leadUnderwriters.length > 0}
      value={leadUnderwriters.join(', ')}
    />
  );

  const formattedOtherUnderwriters = otherUnderwriters.length
    ? otherUnderwriters.join(', ')
    : undefined;

  return (
    <div className={styles.root}>
      {formattedLeadUnderwriters}
      {formattedOtherUnderwriters && (
        <Tooltip
          label={formattedOtherUnderwriters}
          placement="bottom-start"
          hasArrow={false}
        >
          <span className={styles.styledSpan}>
            {t('screener:screenerEvents.moreUnderwriters', {
              count: otherUnderwriters.length,
            })}
          </span>
        </Tooltip>
      )}
    </div>
  );
};
